import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getAttachmentOptions(patientId, params = null) {
        return Axios.get(`${baseURL}patient/${patientId}/attachments`, {
            params
        }).then(response => response.data.response);
    },
    addAttachment(letterId, params) {
        return Axios.post(
            `${baseURL}patient/letter/${letterId}/update-attachment`,
            params
        ).then(response => response.data);
    }
};
